// extracted by mini-css-extract-plugin
export default {"client":"client_style_client__QySx-","select":"client_style_select__K+V+Y","button":"client_style_button__Se82T","itemMenu":"client_style_itemMenu__TKOBb"};